import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props { children: ReactNode; }
interface State { error: Error | null; stack: string; }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, stack: "" };

  static getDerivedStateFromError(error: Error): State {
    return { error, stack: "" };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("[ErrorBoundary] crash:", error.message);
    console.error("[ErrorBoundary] component stack:", info.componentStack);
    this.setState({ stack: info.componentStack ?? "" });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 32, fontFamily: "monospace", maxWidth: 800, margin: "0 auto" }}>
          <h2 style={{ color: "#DC2626", marginBottom: 8 }}>렌더링 오류</h2>
          <pre style={{ whiteSpace: "pre-wrap", fontSize: 13, color: "#DC2626", background: "#FEF2F2", padding: 12, borderRadius: 6, marginBottom: 12 }}>
            {this.state.error.message}
          </pre>
          <pre style={{ whiteSpace: "pre-wrap", fontSize: 11, color: "#475569", background: "#F8FAFC", padding: 12, borderRadius: 6, border: "1px solid #E2E8F0" }}>
            {this.state.stack || "(component stack unavailable — open DevTools console for details)"}
          </pre>
          <button
            style={{ marginTop: 16, padding: "8px 16px", cursor: "pointer", borderRadius: 6, border: "1px solid #E2E8F0", background: "#F8FAFC" }}
            onClick={() => this.setState({ error: null, stack: "" })}
          >
            다시 시도
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
